<template>
    <header
        class="sticky top-0 z-10 flex max-h-[118px] min-h-[118px] flex-col items-center justify-between border-b bg-white px-4 pb-2 pt-2 lg:max-h-[136px] lg:min-h-[136px] lg:py-6"
    >
        <div
            class="container mx-auto flex h-full w-full justify-between px-0 lg:px-12 relative"
        >
            <div class="lg:flex lg:flex-col lg:gap-8">
                <a :href="landingRoute" class="hidden lg:flex">
                    <v-icon icon="n24-beta"></v-icon>
                </a>
                <a
                    @click="previousSection"
                    class="flex cursor-pointer items-center space-x-2 rounded-full px-4 py-3 text-form text-black-78 hover:bg-green-10"
                >
                    <v-icon icon="back" size="5"></v-icon>
                    <label>Nazaj</label>
                </a>
            </div>
            <v-register-stepper
                :step="step"
                class="-mx-4 self-end pb-[22px] max-lg:pb-3 max-md:absolute max-md:bottom-2 max-md:px-4 md:max-w-md xl:max-w-2xl 2xl:max-w-3xl"
            ></v-register-stepper>
            <div>
                <a
                    class="flex items-center space-x-2 rounded-full px-4 py-3 text-form text-black-78 hover:bg-green-10"
                    :href="landingRoute"
                >
                    <v-icon icon="close" size="5"></v-icon>
                    <label>Zapri</label>
                </a>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    props: {
        step: {
            type: Number,
            default: 0,
        },
        landingRoute: {
            type: String,
            default: "",
        },
    },
    methods: {
        previousSection() {
            if (this.step > 1) {
                javascript: history.back();
                //this.$emit("previous", this.step);
            } else {
                // handle case for step 1 here; like heading back
                javascript: history.back();
            }
        },
    },
};
</script>
